module.exports = __webpack_public_path__ + "static/media/blog-category2.b1a477a0.png";